import React from 'react';
import { App } from 'modules/app/App';
import { createRoot } from 'react-dom/client';
import { browserHistory } from '@packages/router-dom';

declare global {
	interface Window {
		UiApplicationInsightsKey?: string;
		__restore_window_scroll: boolean;
		dataLayer: {
			push: (...args: unknown[]) => void;
		};
	}
}

async function initApplicationInsights() {
	const [ReactPlugin, ApplicationInsights] = await Promise.all([
		import('@microsoft/applicationinsights-react-js').then((m) => m.ReactPlugin),
		import('@microsoft/applicationinsights-web').then((m) => m.ApplicationInsights),
	]);

	const { UiApplicationInsightsKey } = window;

	if (typeof UiApplicationInsightsKey !== 'string' || UiApplicationInsightsKey.trim().length === 0) {
		return;
	}

	const reactPlugin = new ReactPlugin();
	const appInsights = new ApplicationInsights({
		config: {
			instrumentationKey: UiApplicationInsightsKey,
			extensions: [reactPlugin],
			extensionConfig: {
				[reactPlugin.identifier]: { history: browserHistory },
			},
		},
	});
	appInsights.loadAppInsights();
}

initApplicationInsights();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);
